import { Check, X, Gift, Plus } from "lucide-react";
import { Button } from "./ui/button";
import { money } from "../lib/api";
import { useBuy } from "./BuyDialog";

const Row = ({ r }) => {
  const { buy } = useBuy();
  return (
    <div data-testid={`domain-result-${r.domain}`} className="flex items-center gap-3 border-b px-4 py-3 last:border-0">
      {r.available ? <Check className="h-4 w-4 shrink-0 text-secondary" /> : <X className="h-4 w-4 shrink-0 text-muted-foreground" />}
      <span className={`flex-1 truncate font-mono-data text-sm ${r.available ? "text-foreground" : "text-muted-foreground line-through"}`}>{r.domain}</span>
      {!r.available && <span className="rounded bg-muted px-2 py-0.5 text-xs font-semibold text-muted-foreground" data-testid="domain-label-taken">Taken</span>}
      {r.available && r.free && (
        <span className="flex items-center gap-1 rounded bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-700" data-testid="domain-label-free">
          <Gift className="h-3 w-3" /> Free with internet or hosting
        </span>
      )}
      {r.available && !r.free && (
        <span className="text-sm font-semibold" data-testid="domain-label-price">{money(r.price, r.currency)}<span className="text-xs font-normal text-muted-foreground">/yr</span></span>
      )}
      {r.available && (
        <Button size="sm" variant="outline" data-testid={`domain-add-btn-${r.domain}`}
          onClick={() => buy({ kind: "domain", domain: r.domain, name: r.domain, price: r.price })}>
          Buy
        </Button>
      )}
    </div>
  );
};

export const DomainResults = ({ data }) => (
  <div data-testid="search-results-container" className="overflow-hidden rounded-lg border bg-white text-foreground">
    {data.results.map((r) => <Row key={r.domain} r={r} />)}
    {data.suggestions.length > 0 && (
      <>
        <p className="bg-muted px-4 py-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Suggestions</p>
        {data.suggestions.map((r) => <Row key={r.domain} r={r} />)}
      </>
    )}
    {data.mode === "simulated" && (
      <p className="bg-amber-50 px-4 py-2 text-[11px] text-amber-800" data-testid="domain-simulated-note">Availability is SIMULATED until registrar credentials are connected.</p>
    )}
  </div>
);
